import { ref, reactive, computed } from 'vue';

export function useTablePagination<T = any>() {
  const currentPage = ref<number | undefined>(1);
  const currentPageSize = ref<number | undefined>(10);

  const pageSizeOptions = reactive<string[]>(['10', '20', '50', '100', '200']);
  const total = ref<number | undefined>(0);
  const getTotal = computed(() => {
    return total.value;
  });
  const tablePagination: any = computed(() => ({
    total: total.value,
    current: currentPage.value,
    pageSize: currentPageSize.value,
    showSizeChanger: true,
    pageSizeOptions: pageSizeOptions,
    size: 'large',
    showTotal: (total) => `共${total}条`,
  }));
  function handleTableChange(page: any, callback) {
    console.log(page);
    page?.pageSize !== currentPageSize.value
      ? (currentPage.value = 1)
      : (currentPage.value = page?.current);
    currentPageSize.value = page?.pageSize;
    console.log(tablePagination.value);
    callback({ page: currentPage.value, pageSize: currentPageSize.value });
  }
  function setPage(pageInfo) {
    currentPage.value = pageInfo.page;
    currentPageSize.value = pageInfo.pageSize;
  }

  function setCurrentPage(page: number) {
    currentPage.value = page;
  }

  function setPageSize(pageSize: number) {
    currentPageSize.value = pageSize;
  }
  function setTotal(totalSize: number | undefined) {
    total.value = totalSize;
  }
  return {
    setCurrentPage,
    tablePagination,
    setPageSize,
    getTotal,
    setTotal,
    setPage,
    handleTableChange,
  };
}
